import { FormHelperText } from '@mui/material';
import styled, { css } from 'styled-components';

export const ButtonWrapper = styled.span`
  display: inline-flex;
`;

/** Start and end zone share a row (Figma review comment): the start zone always opens a new row of the grid. */
export const ZoneField = styled.div<{ $startsRow: boolean }>(
  ({ $startsRow }) => css`
    ${$startsRow && 'grid-column: 1;'}
  `,
);

export const ErrorMessage = styled(FormHelperText)(
  ({ theme: { palette } }) => css`
    font-weight: 700;
    color: ${palette.error.main};
    min-height: 20px;
  `,
);
